import { Checkbox, FormControlLabel } from "@mui/material";

interface Props {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  testId: string;
}

export const FilterCheckbox = ({ label, checked, onChange, testId }: Props) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        size="small"
      />
    }
    label={label}
    data-testid={testId}
    sx={{ ml: 0, mr: 0 }}
  />
);
